var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'ai-fab': true, 'ai-fab-400': _vm.showAi },attrs:{"id":"aiFab"},on:{"click":_vm.openAi}},[_c('span',{staticClass:"icon-white"})])}
var staticRenderFns = []

export { render, staticRenderFns }